import React, { useState, useEffect } from "react";
import { Grid } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import Moment from "moment";



const CloseQut = (props) => {
    const [Mode, setMode] = useState('');
    const [TrackingURL, setTrackingURL] = useState('');
    const [AWBDate, setAWBDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [CourierCompany, setCourierCompany] = useState('');
    const [AWBNumber, setAWBNumber] = useState('');
    const [CourierDtlsUpdatedByID, setCourierDtlsUpdatedByID] = useState(sessionStorage.UserName);
    // const [CourierDtlsUpdatedOn, setCourierDtlsUpdatedOn] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();


    const validationSchema = Yup.object({
        CourierCompany: Yup.string().required('Required!'),
        AWBNumber: Yup.string().required('Required!'),
    });

    const onSubmit = () => {
        // setMode("Insert")
        var CourierDtlsUpdatedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        debugger;
        bodyFormData.append("DeliveryChallanID", props.DeliveryChallanID);
        // bodyFormData.append("CourierDtlsUpdatedOn", CourierDtlsUpdatedOn);
        bodyFormData.append("CourierCompany", CourierCompany);
        bodyFormData.append("AWBNumber", AWBNumber);
        bodyFormData.append("AWBDate", AWBDate);
        bodyFormData.append("TrackingURL", TrackingURL);
        bodyFormData.append("CourierDtlsUpdatedByID", CourierDtlsUpdatedByID);
        fetchData("DeliveryChallan/CourierSave", bodyFormData);
    }

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("DeliveryChallanID", props.DeliveryChallanID);
        fetchGetData("DeliveryChallan/GetByID", bodyFormData);
    }


    useEffect(() => {
        // debugger;
        if ((response.Response === true)) {
            if (response.Message.includes('Closed') === true) {
                alert(response.Message);
            }
            else {
                alert(response.Message);
            }
            props.setCourierOpen(false);
            props.PopulateData();
        }
        else if (response.Response === false) {
            alert('Failed.');
        }
    }, [response])



    useEffect(() => {
        if (responseGetData !== undefined && responseGetData.length > 0) {
            setCourierCompany(responseGetData[0].CourierCompany);
            setAWBNumber(responseGetData[0].AWBNumber);
            setAWBDate(Moment(responseGetData[0].AWBDate).format("YYYY-MM-DD"));
            setTrackingURL(responseGetData[0].TrackingURL);
            // setCourierDtlsUpdatedByID(responseGetData[0].CourierDtlsUpdatedByID);
        }
    }, [responseGetData]);

    useEffect(() => {
        if (props.DeliveryChallanID !== '') {
            getByIDData();
        }
    }, [])


    return (
        <div>
            <Formik initialValues={{
                CourierCompany: CourierCompany, AWBNumber: AWBNumber, AWBDate: AWBDate, TrackingURL: TrackingURL, CourierDtlsUpdatedByID: CourierDtlsUpdatedByID
            }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={5}>
                                <label htmlFor={"CourierCompany"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Courier Company"}
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    name='CourierCompany'
                                    onChange={(e) => setCourierCompany(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={5}>
                                <label
                                    htmlFor={"AWBNumber"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"AWB Number"}
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    name='AWBNumber'
                                    onChange={(e) => setAWBNumber(e.target.value)}
                                />
                            </Grid>
                            <Grid xs={5} >
                                <label
                                    htmlFor={"AWBDate"}
                                    style={{ display: "block", width: "100%", marginLeft: 10 }}
                                >
                                    {"AWB Date"}
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="date"
                                    name="AWBDate"
                                    // disabled={true}
                                    onChange={(e) => setAWBDate(e.target.value)}
                                />
                            </Grid>
                            <Grid xs={5}>
                                <label
                                    htmlFor={"TrackingURL"}
                                    style={{ display: "block", width: "100%", marginLeft: 10 }}
                                >
                                    {"Tracking URL"}
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="TrackingURL"
                                    onChange={(e) => setTrackingURL(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={5}>
                                <label
                                    htmlFor={"CourierDtlsUpdatedBy"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"CourierDtlsUpdatedBy"}
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    name='CourierDtlsUpdatedByID'
                                    disabled={true}
                                // onChange={(e) => setAWBNumber(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setCourierOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
};

export default CloseQut;
